<template>
  <a-checkbox-group v-model:value="checkedList" :options="options" />
</template>
<script setup lang="ts">
import { MarketingScoped } from '@src/scripts/type'
import { computed } from 'vue'

const props = defineProps<{
  value: number
}>()

const emit = defineEmits(['update:value'])

const checkedList = computed({
  get() {
    const arr: number[] = []
    if ((props.value & MarketingScoped.Store) > 0) arr.push(MarketingScoped.Store)
    if ((props.value & MarketingScoped.Out) > 0) arr.push(MarketingScoped.Out)
    return arr
  },
  set(scopeList) {
    let sum = 0
    scopeList.forEach(a => sum += a)
    emit('update:value', sum)
  }
})

const options = [
  { label: '堂食', value: 1 },
  { label: '外卖', value: 2 },
]

</script>